import React from 'react';

export const Phone: React.FC<React.HTMLAttributes<SVGElement>> = (props) => (
  <svg viewBox="2 2 20 20" {...props}>
    <path
      d="M19.641 16.655l-2.471-2.477a1.286 1.286 0 00-1.817.034l-1.245 1.247-.246-.137a12.389 12.389 0 01-2.993-2.17A12.485 12.485 0 018.7 10.146c-.046-.084-.09-.164-.134-.241l.834-.836.411-.412a1.292 1.292 0 00.033-1.821L7.373 4.359a1.285 1.285 0 00-1.816.034l-.7.7.019.019a4.039 4.039 0 00-.571 1.017 4.214 4.214 0 00-.255 1.029c-.326 2.711.91 5.188 4.264 8.548 4.637 4.647 8.374 4.3 8.535 4.279a4.167 4.167 0 001.03-.259 4.011 4.011 0 001.009-.573l.015.014.705-.692a1.3 1.3 0 00.033-1.82z"
      fill="currentColor"
    />
  </svg>
);
